import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { ProductService } from 'src/app/services/product.service';
import { AppSettings } from 'src/app/enums/app-settings.enum';
import { from, of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { SkuDataService } from 'src/app/services/sku-data.service';
// import { SwiperOptions } from 'swiper';
// import Swiper core and required modules
import SwiperCore, { Navigation , SwiperOptions } from 'swiper';
import { ApplicationInitializationService } from 'src/app/services/application-initialization.service';
import { SubjectService } from 'src/app/services/subject.service';
import { ModalController } from '@ionic/angular';
import { ArenaProDataService } from 'src/app/services/arena-pro-data.service';
import { auto } from '@popperjs/core';

// install Swiper modules
SwiperCore.use([Navigation]);

@Component({
  selector: 'app-item-card',
  templateUrl: './item-card.component.html',
  styleUrls: ['./item-card.component.scss'],
})

export class ItemCardComponent implements OnInit {
  public productData: any = '';
  public platformData: any;
  public selectedData: any[]=[];
  public selectedController: any='';
  selectedDevice: any=[];
  multiSkus: any
  language: string;
  isArabic: boolean;
  @Output() selectType = new EventEmitter<any>();
  ARENA_PRO_PRODUCT_CATEGORY: any;
  constructor(
    private UTS: UtilitiesService,
    private PS: ProductService,
    private SKUDS:SkuDataService,
    private APINITS:ApplicationInitializationService,
    private SS: SubjectService,
    private modalController: ModalController,
    private APDS:ArenaProDataService
  ) {
   this.ARENA_PRO_PRODUCT_CATEGORY = this.APINITS.environmentConfig.ARENA_PRO_PRODUCT_CATEGORY;
   this.SS.arenaProAddonBackToOptinalDevices.subscribe((r) => {
    if (r) {
      this.selectedData=[];
      this.selectedController = [];
      this.APDS.selectedData = [];
    }
  });
  }
  swiperPlansConfig: SwiperOptions = {
    navigation: true,
    keyboard: true,
    scrollbar: false,
    slidesPerView: 4,
    spaceBetween: 24,
    breakpoints: {
      // when window width is >= 320px
      320: { slidesPerView: 1.9},
      541: { slidesPerView: 2},
      768: { slidesPerView: 2},
      1024: { slidesPerView: 4},
      1440: { slidesPerView: 5},
    },
  };
  swiperPlansButtonConfig: SwiperOptions = {
    navigation: true,
    keyboard: true,
    scrollbar: false,
    slidesPerView: 2.5,
    spaceBetween: 8,
    breakpoints: {
      // when window width is >= 320px
      541: { slidesPerView: 2},
      768: { slidesPerView: 3},
      1024: { slidesPerView: 4},
      1440: { slidesPerView: 4},
    },
  };

  ngOnInit() {
    this.getPlatforms(this.ARENA_PRO_PRODUCT_CATEGORY);
    const locale = this.UTS.getLocaleLanguage().toLocaleLowerCase()
    if (locale == 'ar') {
      this.isArabic = true;
    } else {
      this.isArabic = false;
    }
  }


    getPlatforms(catId:any='catapcontrollers'){
      this.PS.getCategories(catId).subscribe(async (res:any)=>{
        this.platformData = res?.childCategories?.items || [];
        this.selectedController = this.platformData && this.platformData[0].id;
        const data = await this.getSelectedSubCategory(this.selectedController ||  'catapcios','');
        this.productData = data && data?.products?.map((res:any)=>{
          res['check'] = false;
          return res;
        }) || [];
        this.selectedData = [];
      });
    }



  private async getSelectedSubCategory(ID: string, NS: string) {
    try {
      const response = await this.PS.getProductsByCategory(
        this.UTS.getLocaleLanguage(),
        AppSettings.IS_APPLY_DEFAULT_FILTERS,
        ID,
        NS,
        AppSettings.NO,
        null,
        "OldDevice"
      ).toPromise();
      return response;
    } catch (e) {
      this.UTS.error(e.message);
      return '';
    }
  }

  async changeContoller(controller:any){
        this.selectedController = controller && controller?.id;
        const data = await this.getSelectedSubCategory(this.selectedController ||  'catapcios','');
        this.productData = data && data?.products?.map((res:any)=>{
          res['check'] = false;
          return res;
        }) || [];
       this.selectedData = [];
  }

  calculatePercentage(product:any) {
    return Math.floor(100 -((product?.price* 100)/product?.oldPrice ))
  }

  floorNumber(number:any){
    return Math.floor(number)
  }

  addItem(product:any,i:any){
    this.productData[i]['check'] =  !this.productData[i]['check'];
    const index = this.selectedData.findIndex(x=>x?.productId == product?.productId)
    if(index == -1){
      this.selectedData
      .push(product);
      this.APDS.selectedData.push(product);
    }else{
      this.selectedData.splice(index,1);
      this.APDS.selectedData.splice(index,1);
    }
  }

  totalAmount(){
    let total :any = 0;
    this.selectedData.forEach((data:any) => {
      total += +data?.price
    });
    return total;
  }

  subscribeAndCheckout(){
    if (this.selectedData.length > 0) {
      //sku service call after that sucess check if isInStock in false any one then redirect to inverntory popup
      // otherwise call addon service and reidect to success page with inventory details  
      this.multiSkus = this.concatenateskus(this.APDS.selectedData)
      if (this.multiSkus) {
        this.PS.getSkuDetails(this.multiSkus)
          .subscribe((r: any) => {
            if (r) {
              this.selectedDevice = r?.items;
              this.APDS.selectedData.forEach((data:any)=>{
                 const index = this.selectedDevice.findIndex((x:any)=>x?.id == data?.itemId);
                 if(index > -1){
                  this.selectedDevice[index] = {...this.selectedDevice[index],...data};
                  this.selectedDevice[index]['productId'] = data?.productId;
                }
              });
              this.APDS.selectedData = this.selectedDevice;
              sessionStorage.setItem('SELECTED_DEVICES',JSON.stringify(this.APDS.selectedData))
              this.SS.arenaProAddonSelectType.next({ 'type': 'Sku', 'data': this.selectedDevice })
              this.selectType.emit({ 'type': 'Sku', 'data': this.selectedDevice })
              this.SS.reloadDevicesList.next(true)
            }
            // if(this.selectedDevice.length ==  this.selectedData.length){
            //   this.selectType.emit({'type':'Sku','data':this.selectedDevice})
            // }
          }, (e) => {
          });
      }
    } else {
      this.SS.arenaProAddonSelectType.next({ 'type': 'Addon', 'data': '' })
      this.selectType.emit({ 'type': 'Addon', 'data': '' })
    }
  }
  
  concatenateskus(selectedDevice: { itemId: string }[]): string {
    return selectedDevice.map(sku => sku?.itemId).join(",");
  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      dismissed: true,
    });
  }
}
